import { render, staticRenderFns } from "./v-area-input.vue?vue&type=template&id=689d4a63&scoped=true&"
import script from "./v-area-input.vue?vue&type=script&lang=js&"
export * from "./v-area-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689d4a63",
  null
  
)

export default component.exports